import cn from 'bem-cn';

import { ScreenSize, useGetScreenSize, useImageLoad } from '../../../hooks';
import { useModal } from '../../../contexts';
import { Stack } from '../../UI';

import euroslot from '../../../images/achievement/euroslot.svg';
import { AchievementCardProps } from './AchievementCard.types';
import { useAchievementCardParallax } from './AchievementCard.hooks';
import './AchievementCard.scss';

const b = cn('achievement-card');

export const AchievementCard = (props: AchievementCardProps) => {
    const { title, description, imageData, owned } = props.achievement;
    const { backgroundImageUrl, achievementImageUrl } = imageData;

    const screenSize = useGetScreenSize();
    const needHover = screenSize >= ScreenSize.SmallDesktop;

    const { achievement: achievementModal } = useModal();
    const isImageLoaded = useImageLoad(backgroundImageUrl);

    const { panelRef, subpanelRef, cardParallaxStyle, backgroundStyle } = useAchievementCardParallax({
        needHover,
        backgroundImageUrl,
        owned,
    });

    const handleAchievementClick = () => {
        achievementModal.open({ achievementId: props.achievement.id });
    };

    return (
        <div
            ref={panelRef}
            className={b({ owned: owned && isImageLoaded, 'with-hover': needHover })}
            style={cardParallaxStyle}
            onClick={handleAchievementClick}
        >
            <div className={b('background')} ref={subpanelRef} style={backgroundStyle}>
                <img className={b('euroslot')} src={euroslot} alt="" />
            </div>
            <Stack className={b('content')}>
                <img className={b('image')} src={achievementImageUrl} alt="" />
                <Stack className={b('text-content')}>
                    <h3>{title}</h3>
                    <p>{description}</p>
                </Stack>
            </Stack>
        </div>
    );
};
